module.exports = __webpack_public_path__ + "static/media/icon_info_2.e5109923.svg";